// extracted by mini-css-extract-plugin
module.exports = {"scrollable":"scrollable_scrollable__YXd_7","scrollable--no-scrollbar":"scrollable_scrollable--no-scrollbar__F4n5c"};